import { LineStatus } from 'my-account/constants';
import { ChildModel, ModelBase } from 'store/model-base';
import { AccountDetail } from './account-detail';
import { PendingLine } from './pending-line';

export class PendingLineTransfer extends ModelBase {
    public static storeName: string = 'pendingLineTransfer';

    public transferSessionId: string;
    public creationDate: string;
    public sourceAccount: AccountDetail;
    public targetAccount: AccountDetail;
    public originatingAccount: string;
    public lines: PendingLine[];
    public transferPinExpires: string;
    public status: string;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        return super.create<T>(data);
    }
    
    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'lines',
            model: PendingLine
        }];
    }

    public isPendingSourceAccount(authId: string): boolean {
        return this.sourceAccount.msoAccountId === authId;
    }

    public getPendingLineByValue(value: string): boolean {
        return this.lines.some((line: PendingLine) => line.lineId === value && (line.status === LineStatus.PENDING || line.status === LineStatus.PENDING_CANCEL));
    }

    public getPendingLineByKey(key: string): boolean {
        return this.lines.some((line: PendingLine) => line.lineId === key && (line.status === LineStatus.PENDING || line.status === LineStatus.PENDING_CANCEL));
    }
}
